





import Vue from "vue";
import { firebase_config, initial_app_settings } from "@/config/config";
export default Vue.extend({
  data() {
    return {
      firebase_config: null
    };
  },
  created() {
    this.firebase_config = firebase_config;
    document.title = `${initial_app_settings.app_title} - Powered by Cognizant® Assist`;
    document.body.classList.add(firebase_config.projectId);
  }
});
